import { render, staticRenderFns } from "./FormSizeControl.vue?vue&type=template&id=af94bf08"
import script from "./FormSizeControl.vue?vue&type=script&lang=js"
export * from "./FormSizeControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports